export default __webpack_public_path__ + "static/media/CaptureBands.c50b4152.gif";